module.exports = __webpack_public_path__ + "img/clipboard.beed0c4f.png";